const filmInfo = [
  {
    id: "film/the-matrix-poster.jpeg",
    title: "THE MATRIX",
    year: "1999",
    rating: "8.7/10",
  },
  {
    id: "film/the-matrix-reloaded-poster.jpeg",
    title: "THE MATRIX RELOADED",
    year: "2003",
    rating: "7.2/10",
  },
  {
    id: "film/the-matrix-revolutions-poster.jpeg",
    title: "THE MATRIX REVOLUTIONS",
    year: "2003",
    rating: "6.7/10",
  },
  {
    id: "film/the-matrix-resurrections-poster.jpeg",
    title: "THE MATRIX RESURRECTIONS",
    year: "2021",
    rating: "5.7/10",
  },
];

export default filmInfo;
